<template>
  <div>
    <Subheader title="Funding History"></Subheader>

    <div class="app-content-column">
      <div class="card">
        <h4>Transactions</h4>
        <table v-if="paymentDataLoaded" class="table">
          <thead>
            <tr>
              <th>Amount</th>
              <th>Goal</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="payment in payments" :key="payment.id">
              <td>{{ (payment.amount / 100) | formatNumberAsUSD }}</td>
              <td>
                <strong>{{ payment.goalRef ? `${payment.goalRef.title}:` : '' }}</strong>
                {{ payment.goalRef ? payment.goalRef.description : '' }}
              </td>
              <td>{{ payment.datetimeCreated | momentDateTime }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Subheader from '@/components/Subheader'
import Payment from '@/services/payments'

import { mapState } from 'vuex'

export default {
  name: 'Project',
  components: {
    Subheader,
  },
  data() {
    return {
      paymentFilters: {
        funder: null,
      },
      payments: [],
      paymentDataLoaded: false,
    }
  },
  computed: {
    ...mapState(['user']),
  },
  created() {
    this.paymentFilters.funder = this.user.id
    this.refreshData()
  },
  methods: {
    refreshData() {
      Payment.api.list().then(data => {
        this.payments = data.results
        this.paymentDataLoaded = true
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/buttons';
@import '../styles/mixins/cards';
@import '../styles/mixins/tables';
@import '../styles/forms';
@import '../styles/layout';

.card {
  @include card-w-borders();
}
</style>
